import platform from "platform";
import storage from "./storage";

// URLからロールを取得する
export const pathRole = () => {
  const { pathname } = window.location;

  if (pathname.indexOf("/admin/") > -1) {
    return "admin";
  } else if (pathname.indexOf("/customer_admin") > -1) {
    return "customer_admin";
  } else if (pathname.indexOf("/answer/") > -1) {
    return "answer";
  } else if (pathname.indexOf("/preview/") > -1) {
    return "preview";
  }

  return null;
};

export const isAdmin = () => {
  return pathRole() === "admin";
};

export const isCustomerAdmin = () => {
  return pathRole() === "customer_admin";
};

export const isAnswer = () => {
  return pathRole() === "answer";
};

export const isPreview = () => {
  return pathRole() === "preview";
};

export const convertLocaleKeyToName = key => {
  switch (key) {
    case "ja":
      return "日本語";
    case "en":
      return "英語";
    case "zh":
      return "中国語";
    case "vi":
      return "ベトナム語";
    default:
      return null;
  }
};
export const convertLocaleNameToKey = name => {
  switch (name) {
    case "日本語":
      return "ja";
    case "英語":
      return "en";
    case "中国語":
      return "zh";
    case "ベトナム語":
      return "vi";
    default:
      return null;
  }
};

export const isPlatform = name => platform.name.indexOf(name) > -1;

export const isSupportBrowser = () => {
  // IE,FireFox以外は対応
  return !(
    (platform.name.indexOf("IE") > -1 &&
      platform.version.indexOf("11.") === -1) ||
    platform.name.indexOf("Firefox") > -1
  );
};

export const charcount = str => {
  let len = 0;
  const wstr = escape(str);
  for (let i = 0; i < wstr.length; i += 1, len += 1) {
    if (wstr.charAt(i) === "%") {
      i += 1;
      if (wstr.charAt(i) === "u") {
        i += 3;
        len += 1;
      }
      i += 1;
    }
  }
  return len;
};

export const fmtIndustryName = (industries, largeId, middleId) => {
  const large = industries.large.find(v => v.id === largeId);
  if (!large) {
    return "";
  }
  const middle = industries.middle.find(v => v.id === middleId);
  if (!middle) {
    return large.name;
  }
  return `${large.name} - ${middle.name}`;
};

export const answerLoginURL = () => `/login/survey/${storage.getUrlToken()}`;



// WEBPACK FOOTER //
// ./src/utils/formatter.js